import { render, staticRenderFns } from "./RotatingGameCard.vue?vue&type=template&id=5a173eca&scoped=true&"
import script from "./RotatingGameCard.vue?vue&type=script&lang=js&"
export * from "./RotatingGameCard.vue?vue&type=script&lang=js&"
import style0 from "./RotatingGameCard.vue?vue&type=style&index=0&id=5a173eca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a173eca",
  null
  
)

export default component.exports